<template>
  <div
    :ref="generateSafeId(fieldQuestionId, 'wrapper')"
    class="RMPE-DynamicField"
  >
    <component
      :is="layout.type"
      :image="layout.image"
      :video="layout.video"
    >
      <div class="field">
        <div class="control">
          <div
            class="RMPE-CustomLabel "
            :class="labelStyle"
          >
            <span
              ref="labelContent"
              v-html="question.formattedLabel"
            />
          </div>

          <HintMessage :hint="question.formattedDescription" />

          <MediaMiddlePartial :layout="layout" />
        </div>
        <div class="RMPE-DynamicForm-SubmitContainer isNotAnswerable">
          <button
            ref="auto-focus-target"
            :disabled="isNextButtonDisabled"
            class="button is-primary RMPE-CustomSubmit"
            @click="goToNextQuestion"
          >
            {{ question.goToNextQuestionButtonLabel }}
          </button>
          <span
            v-if="!isTouchDevice"
            class="RMPE-CustomSubmit-Hint"
          >
            press <span class="is-family-code has-text-weight-bold ">Enter</span> <kbd>↵</kbd>
          </span>
        </div>
      </div>
    </component>
  </div>
</template>

<script>
import DynamicFieldMixin from '../../mixins/dynamic-field-mixin';
import LabelFieldMixin from '../common/label-field';

export default {
  mixins: [DynamicFieldMixin, LabelFieldMixin],

  methods: {
    goToNextQuestion() {
      this.$emit('go-to-next-question');
    },
  },
};
</script>

<style scoped lang="scss">
.is-size-4 {
  font-weight: 600;
}
</style>
